export default __webpack_public_path__ + "static/media/Biology.95de06d9.pdf";